import React, { useState } from 'react'

function CrowdFunding() {
    const [openCustomFunding, setOpenCustomFunding] = useState(false)
    const [inputValue, setInputValue] = useState({
        amount : "",
        description: ""
    })
    const [customAmount, setCustomAmount] = useState(null)
    const [clickedAmount, setClickedAmount] = useState(null)
    const hardCodedAmounts = [5, 10, 20, 50, 100]

    const handleFunding = (e) => {
        e.preventDefault()

    }



  return (
    <div>
    <p className='my-12'>Project Description: Encourage participation in community service and volunteer programs
             to promote a sense of unity and address social issues. This will not only help address specific 
             problems within the community. </p>

        <p>First 100 Funders - 1PST = 0.05 Revenue</p>

        <div className='my-8 font-light italic space-y-2'>
            <p>$10 - Thank You stickers</p>
            <p>$50 - Solar Group Shirt and Hats</p>
            <p>$30 - Keep the good work</p>
        </div>


        {/* FUNDING */}
        <div className='my-8'>
            <p className='font-semibold'>Fund:</p>

            <form onSubmit={handleFunding}>
            <div className='flex flex-wrap'>
            {hardCodedAmounts.map((item, idx) => {
                return (
                    <button 
                    type='button'
                     onClick={() => {
                        setClickedAmount(item)
                        setCustomAmount(null)
                        setInputValue((prevValue) => {
                            return {
                                ...prevValue,
                                amount : item
                            }
                        })
                    }}
                    key={idx}
                    className={`${clickedAmount === item ? "bg-enhancedTeal text-white" : "bg-white text-black"} 
                    font-semibold mr-3 my-3  px-8 rounded-md py-2`}>
                    ${item}</button>
                )
            })}
            </div>

            <div className='relative mt-4 text-black'>
            <button 
            type='button'
            onClick={() => setOpenCustomFunding(!openCustomFunding)} 
            className='bg-white px-8 rounded-md py-2'>
            Custom: <b>${customAmount}</b></button>

            <div className={`w-full absolute top-[35px] left-0  my-2 transform transition-all duration-300 ease-in-out
            ${openCustomFunding ? "opacity-100 translate-y-0 z-[3]" : "h-0 opacity-10 -z-10 -translate-y-4"}
            `}>
            <div className='flex flex-col w-full bg-white rounded-md py-6 px-3'>
                <p className='my-2'>Enter an Amount</p>

                <div className='relative'>
                <input 
                type='number' 
                className='text-xl font-semibold w-full mb-5 pl-8  px-4 py-2 rounded-md'
                value={inputValue?.amount}
                onChange={(e) => {
                    setInputValue((prevValue) => {
                            return {
                                ...prevValue,
                                amount : parseInt(e.target.value)
                            }
                        })
                }}
                 />
                 <div className='absolute top-0 px-3 py-2.5'>
                    <p className='text-xl font-semibold'>$</p>
                 </div>
                </div>

                <button 
                type='button'
                onClick={(e) => {
                    setClickedAmount(null)
                    setCustomAmount(inputValue.amount)
                    setOpenCustomFunding(!openCustomFunding)
                }}
                className='transition-all ease-linear hover:-translate-x-[5px]  w-2/5 mr-3 bg-enhancedTeal text-white px-8 rounded-md py-2'>
                Confirm
                </button>
            </div>
            </div>
            </div>

            <div className='my-5 space-y-3'>
                <p className='font-semibold'>Add Note:</p>
                <textarea 
                className=' text-black font-semibold w-full mb-5 px-4 py-3 rounded-md'
                value={inputValue?.description}
                onChange={(e) => {
                    setInputValue((prevValue) => {
                            return {
                                ...prevValue,
                                description : e.target.value
                            }
                        })
                }}
                >
                </textarea>
            </div>

            <div className='flex w-full justify-end'>
            <button className='transition-all ease-linear hover:translate-x-[5px]  w-2/5 mr-3 bg-greenCustom text-white px-8 rounded-md py-2'>
                Fund
                </button>
            </div>

            </form>
        </div>

        
    </div>
  )
}

export default CrowdFunding
